import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TabsInterface, TranslocoFunction } from '../../types';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-tabs',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslocoPipe,
    NgbTooltip,
    KeeniconComponent,
    NgClass,
  ],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent {
  tabs = input<TabsInterface[]>([]);
  singleView = input<boolean>(false);
  t = input<TranslocoFunction>();
}
